<div class="ovivio-logo">
  <img class="logo-icon" src="./assets/images/logo-ovivio-square.png" alt="Ovivio" />
  <div class="logo-text">
    <div class="logo-title">{{ title }}</div>
    <div class="logo-subtitle">by Ovivio</div>
  </div>
</div>
